export default __webpack_public_path__ + "static/media/icon-tributei.c5c0f189.svg";